/**
 * Created by Mark on 17/04/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

class LessonPlanStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.plans = [];
    }


    _registerToActions(action) {

        switch(action.actionType)
        {
            case Constants.ALL_LESSONS :
                this.plans = action.response;
                this.emitChange();
                break;
        }
    }

    getPlans(){
        return this.plans
    }
}

export default new LessonPlanStore();